import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/blog/BlogPageClient.tsx");
